var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import History from 'helpers/History';
import { T } from 'helpers/i18n';
import { Button, FieldType, Input } from 'elements';
let UserRecovery = class UserRecovery extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            client: '',
            email: ''
        };
        this.handleChange = (event) => {
            this.setState({ [event.target.name]: event.target.value });
        };
        this.handleSubmit = () => {
            this.props.store.users
                .recovery(this.state)
                .then(() => History.replace('/'));
        };
        this.handleCancel = () => {
            History.replace('/login');
        };
    }
    render() {
        const { client, email } = this.state;
        return (React.createElement(Wrapper, null,
            React.createElement(InsideWrapper, null,
                React.createElement(StyledInput, { label: T('client'), name: 'client', value: client, type: FieldType.Text, onChange: this.handleChange }),
                React.createElement(StyledInput, { label: T('email'), name: 'email', value: email, type: FieldType.Text, onChange: this.handleChange, onSubmit: this.handleSubmit })),
            React.createElement(ButtonWrapper, null,
                React.createElement(CancelButton, { secondary: true, onClick: this.handleCancel }, T('cancel')),
                React.createElement(SendButton, { primary: true, loading: 'post@login', onClick: this.handleSubmit }, T('send')))));
    }
};
UserRecovery = __decorate([
    inject('store'),
    observer
], UserRecovery);
export default UserRecovery;
const Wrapper = cxs('div')({});
const InsideWrapper = cxs('div')({
    padding: Theme.size.space[4]
});
const ButtonWrapper = cxs('div')({
    borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    marginTop: Theme.size.space[1]
});
const StyledInput = cxs(Input)({
    padding: Theme.size.space[1]
});
const CancelButton = cxs(Button)({
    width: '50%',
    borderRight: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    padding: Theme.size.space[2]
});
const SendButton = cxs(Button)({
    width: '50%',
    padding: Theme.size.space[2]
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Users/containers/UserRecovery.tsx
// module id = 579
// module chunks = 0